import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";

const EditCrewValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";

  const checkCrew = (crew) => {
    let errors = [];

    if ( !crew || crew.length < 2)
      errors.push(`At least 'Captain' and 'First Officer' should be included in the crew list`);

    if (crew && Array.isArray(crew)) {
      for (let i = 0; i < crew.length; i++) {
        const crewRecord = crew[i];
        if (!crewRecord.code || crewRecord.code === "") {
          errors.push(`Flight crew members must be associated to all crew functions`);
        }
      }
    }

    return errors;
  }

  if (!error) {
    const crewErrors = checkCrew(record.crew);
    if (crewErrors && crewErrors.length > 0) {
      error = true;
      errorMessage = crewErrors[0];
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default EditCrewValidator;
